module.exports = __webpack_public_path__ + "static/media/varka-9.655d21df.png";